export function getCadenceTransitionNotice({ previous = null, next = null } = {}) {
  if (!previous || !next) return '';
  const previousMode = previous.mode === 'member_choice' ? 'member_choice' : 'fixed';
  const nextMode = next.mode === 'member_choice' ? 'member_choice' : 'fixed';
  const previousUnit = previous.unit === 'month' ? 'month' : 'year';
  const nextUnit = next.unit === 'month' ? 'month' : 'year';
  if (previousMode === nextMode && (nextMode !== 'fixed' || previousUnit === nextUnit)) return '';

  if (nextMode === 'member_choice') {
    return 'Existing members will keep their current monthly or yearly cadence. The current adjustment for that cadence will apply at renewal, and members can choose a different cadence later.';
  }

  const cadenceLabel = nextUnit === 'month' ? 'monthly' : 'yearly';
  return `Existing members will move to the ${cadenceLabel} cadence at their next renewal. They will not be charged when you save these settings.`;
}

export function buildCadenceMirrorFields({ cadenceMode, fixedInterval, memberChoice, deleteValue }) {
  return cadenceMode === 'fixed'
    ? { fixedInterval, memberChoice: deleteValue }
    : { memberChoice, fixedInterval: deleteValue };
}

export function normalizeCadencePolicy(value = {}) {
  const mode = value?.cadenceMode === 'member_choice' || value?.mode === 'member_choice'
    ? 'member_choice'
    : 'fixed';
  const fixedSource = value?.fixedInterval || value;
  const numberOrZero = input => Number.isFinite(Number(input)) ? Number(input) : 0;
  return {
    cadenceMode: mode,
    fixedInterval: {
      unit: mode === 'fixed' && fixedSource?.unit === 'month' ? 'month' : 'year',
      count: 1,
    },
    memberChoice: {
      monthly: { discountPct: mode === 'member_choice' ? numberOrZero(value?.memberChoice?.monthly?.discountPct) : 0 },
      yearly: { discountPct: mode === 'member_choice' ? numberOrZero(value?.memberChoice?.yearly?.discountPct) : 0 },
    },
  };
}

export function cadencePolicyChanged(previous, next) {
  return JSON.stringify(normalizeCadencePolicy(previous)) !== JSON.stringify(normalizeCadencePolicy(next));
}
